import { Routes } from '@angular/router';
import { PageNotFoundPage, StationNotLoadedPage } from '@splixer/player-ui';

export const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'station_error',
        component: StationNotLoadedPage,
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/station/station.routes').then((m) => m.stationRoutes),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'library',
      },
    ],
  },
  { path: '**', component: PageNotFoundPage },
];
